import { render, staticRenderFns } from "./OnboardingStandardFormModal.vue?vue&type=template&id=686e65e6&scoped=true"
import script from "./OnboardingStandardFormModal.vue?vue&type=script&lang=js"
export * from "./OnboardingStandardFormModal.vue?vue&type=script&lang=js"
import style0 from "./OnboardingStandardFormModal.vue?vue&type=style&index=0&id=686e65e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686e65e6",
  null
  
)

export default component.exports